import React from 'react'
import { updateProjectSolutionMetadata } from '../../store/actions/index';
import ProjectSolutionMetadataModal from './ProjectSolutionMetadataModal';
import { useTranslation } from 'react-i18next';

const EditProjectSolutionMetadataModal = (props) => {

  const { t } = useTranslation();
  const onSubmitAction = (form_data) => {
    return updateProjectSolutionMetadata(props.formObject.productSolutionId, form_data);
  };

  const initialValues = {
      description: props.formObject.description,
      notice: props.formObject.notice,
    };

  return (
    <ProjectSolutionMetadataModal
      modalTitle={ t( 'modal.edit_projectsolution_metadata.title' ) }
      onSubmitAction={onSubmitAction}
      initialValues={initialValues}
    />

  )
}

export default EditProjectSolutionMetadataModal



// WEBPACK FOOTER //
// ./src/components/Modals/EditProjectSolutionMetadataModal.js